import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  text: 'Sesiones sin estructura ni guión profesional'
}, {
  emoji: '🚨',
  text: 'Sin disclaimers ni protección ética para tus consultantes'
}, {
  emoji: '😤',
  text: 'Horas perdidas armando informes desde cero'
}, {
  emoji: '😓',
  text: 'Inseguridad al traducir mensajes canalizados en palabras claras'
}, {
  emoji: '💸',
  text: 'No sabés cómo cobrar ni armar paquetes de sesiones'
}, {
  emoji: '📄',
  text: 'Informes post-sesión que no reflejan tu nivel profesional'
}, {
  emoji: '🔥',
  text: 'Burnout por falta de sistema y flujo de trabajo'
}, {
  emoji: '😟',
  text: 'Consultantes que no vuelven por falta de entregables claros'
}];
export function PainPointsSection() {
  return <section className="py-10 md:py-16 px-4 relative bg-mystic-900" data-id="element-85">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-86"></div>

      <div className="max-w-lg mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-88">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-89">
            Esto es para vos si...
          </h2>
          <p className="text-sm md:text-base text-gray-400" data-id="element-90">
            ¿Te sentís identificada con alguna de estas situaciones?
          </p>
        </motion.div>

        <div className="flex flex-col gap-2.5 md:gap-3 mb-6" data-id="element-91">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-3 bg-mystic-800/60 border-l-3 border-l-gold/60 rounded-lg px-4 py-3" style={{
          borderLeftWidth: '3px'
        }} data-id="element-92">
              <span className="text-lg shrink-0" data-id="element-93">{point.emoji}</span>
              <span className="text-sm md:text-base text-gray-200" data-id="element-94">
                {point.text}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-gold/10 border border-gold/30 rounded-xl px-4 py-3 text-center" data-id="element-95">
          <p className="text-sm md:text-base text-gold-light font-medium" data-id="element-96">
            ✅ Si te identificás con al menos una, el Sistema PRO fue diseñado
            para vos.
          </p>
        </motion.div>
      </div>
    </section>;
}